<!-- Hero Section -->
<section class="page-hero">
  <div class="hero-overlay"></div>
  <div class="hero-content">
    <p class="hero-label">GET IN TOUCH</p>
    <h1 class="hero-title">Contact Us</h1>
    <p class="hero-subtitle">We'd love to hear from you</p>
  </div>
</section>

<!-- Contact Content -->
<section class="contact-section">
  <div class="contact-inner">
    <div class="contact-layout">
      <div class="contact-info">
        <div class="info-block">
          <p class="info-label">LOCATION</p>
          <h3>Visit Us</h3>
          <a class="info-link" href="https://www.google.com/maps/dir//304+N+Appleton+St,+Appleton,+WI+54911" target="_blank">
            304 N Appleton St<br>
            Appleton, WI 54911
          </a>
        </div>
        
        <div class="info-block">
          <p class="info-label">PHONE</p>
          <h3>Call Us</h3>
          <p><a class="info-link" href="tel:920-850-9896">Paige: (920) 850-9896</a></p>
          <p><a class="info-link" href="tel:920-851-7283">Lauren: (920) 851-7283</a></p>
        </div>
        
        <div class="info-block">
          <p class="info-label">EMAIL</p>
          <h3>Write Us</h3>
          <p><a class="info-link" href="mailto:contact.veloursalon@gmail.com">contact.veloursalon&#64;gmail.com</a></p>
        </div>
        
        <div class="info-block">
          <p class="info-label">BOOKINGS</p>
          <h3>Reserve</h3>
          <p class="info-text">Book your appointment online or contact us directly.</p>
          <button type="button" class="book-link" (click)="booking.open()">Book Online <i class="fa-solid fa-arrow-right"></i></button>
        </div>
      </div>
      
      <div class="contact-map">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2856.5!2d-88.4154!3d44.2653!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8803b8a2a2a2a2a3%3A0x0!2s304+N+Appleton+St%2C+Appleton%2C+WI+54911!5e0!3m2!1sen!2sus!4v1"
          width="100%"
          height="100%"
          style="border:0; min-height:450px;"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade">
        </iframe>
      </div>
    </div>
  </div>
</section>

<!-- Social Section -->
<section class="social-section">
  <div class="social-inner">
    <p class="social-label">FOLLOW ALONG</p>
    <h2>Stay Connected</h2>
    <div class="social-links">
      <a href="https://www.instagram.com/veloursalon920/" target="_blank"><i class="fa-brands fa-instagram"></i> Instagram</a>
      <a href="https://linktr.ee/veloursalon" target="_blank"><i class="fa-solid fa-link"></i> Linktree</a>
    </div>
  </div>
</section>